import { render, staticRenderFns } from "./ErroProcessamentoFilaMensagem.vue?vue&type=template&id=13085fca"
import script from "./ErroProcessamentoFilaMensagem.vue?vue&type=script&lang=ts"
export * from "./ErroProcessamentoFilaMensagem.vue?vue&type=script&lang=ts"
import style0 from "./ErroProcessamentoFilaMensagem.vue?vue&type=style&index=0&id=13085fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports